"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueListRequestSchema = void 0;
const zod_1 = require("zod");
const enum_schema_1 = require("../../../common/schemas/enum.schema");
const ChangeItemStatus_1 = require("../../types/ChangeItemStatus");
const ChangeItemType_1 = require("../../types/ChangeItemType");
exports.getValueListRequestSchema = zod_1.z
    .object({
    changeItemStatusId: zod_1.z
        .string()
        .or(zod_1.z.number())
        .transform((val) => Number(val))
        .pipe((0, enum_schema_1.enumSchema)(ChangeItemStatus_1.ChangeItemStatus))
        .optional(),
    changeItemTypeId: zod_1.z
        .string()
        .or(zod_1.z.number())
        .transform((val) => Number(val))
        .pipe((0, enum_schema_1.enumSchema)(ChangeItemType_1.ChangeItemType))
        .optional(),
})
    .strict();
//# sourceMappingURL=getValueListRequest.schema.js.map